var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6296_18348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4736 8.52734H8.52637V27.4746H27.4736V8.52734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4736 35.9998L36 27.4734L31.7368 26.7461L27.4736 27.4734L26.6956 31.3729L27.4736 35.9998Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 27.4734V33.1576C0 34.728 1.27181 35.9998 2.84203 35.9998H8.52637L9.40177 31.7366L8.52637 27.4734L3.88111 26.7461L0 27.4734Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 8.52637V2.84203C36 1.27181 34.7282 0 33.158 0H27.4736C26.955 2.11444 26.6957 3.6705 26.6956 4.66819C26.6956 5.66578 26.9549 6.95184 27.4736 8.52637C29.3594 9.06637 30.7805 9.33637 31.7368 9.33637C32.6932 9.33637 34.1142 9.06647 36 8.52637Z",
    fill: "#1967D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 8.52734H27.4736V27.4746H36V8.52734Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4736 27.4727H8.52637V35.999H27.4736V27.4727Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4736 0H2.84217C1.27181 0 0 1.27181 0 2.84203V27.4736H8.52637V8.52637H27.4736V0Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4129 23.2244C11.7047 22.746 11.2144 22.0473 10.9468 21.1234L12.5905 20.4462C12.7396 21.0146 13.0001 21.4551 13.3721 21.7678C13.7416 22.0804 14.1916 22.2344 14.7174 22.2344C15.2549 22.2344 15.7167 22.0709 16.1028 21.744C16.4889 21.4172 16.6832 21.0004 16.6832 20.496C16.6832 19.9796 16.4795 19.558 16.0721 19.2312C15.6647 18.9044 15.1532 18.741 14.5421 18.741H13.5924V17.1139H14.445C14.9707 17.1139 15.4136 16.9718 15.7736 16.6874C16.1336 16.4033 16.3136 16.0148 16.3136 15.5198C16.3136 15.0794 16.1526 14.7288 15.8305 14.466C15.5085 14.203 15.101 14.0704 14.606 14.0704C14.1228 14.0704 13.7392 14.1983 13.455 14.4564C13.1708 14.7152 12.9573 15.042 12.8344 15.4062L11.2074 14.7288C11.4228 14.1178 11.8184 13.5778 12.3986 13.1112C12.9788 12.6446 13.7202 12.4102 14.6202 12.4102C15.2858 12.4102 15.885 12.5381 16.4155 12.7962C16.946 13.0544 17.3628 13.412 17.6636 13.8668C17.9645 14.3238 18.1136 14.8354 18.1136 15.4038C18.1136 15.984 17.9739 16.4744 17.6945 16.877C17.4151 17.2796 17.0716 17.5874 16.6642 17.803V17.9C17.1902 18.1169 17.6471 18.4731 17.9858 18.9304C18.3292 19.3922 18.5021 19.944 18.5021 20.5883C18.5021 21.2324 18.3386 21.808 18.0118 22.3124C17.685 22.817 17.2327 23.2148 16.6594 23.5038C16.084 23.7928 15.4374 23.9397 14.7197 23.9397C13.8884 23.942 13.1211 23.7028 12.4129 23.2244ZM22.5092 15.0674L20.7046 16.3724L19.8022 15.0036L23.0398 12.6682H24.2808V23.6838H22.5092V15.0674Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6296_18348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google_calendar.9c8564c3a5f7886f5b4854784d10ccec.svg";
export { ForwardRef as ReactComponent };